import React from 'react';
import '../styles/components/flow-step.css';

const FlowStep = ({ stepNumber, children, className = '' }) => {
  return (
    <div className={`flow-step ${className}`}>
      <div className="step-number">
        {stepNumber}
      </div>
      <div className="step-content">
        {children}
      </div>
    </div>
  );
};

export default FlowStep;